export default __webpack_public_path__ + "static/media/49k.82138b1e.md";